<orbit-dialog-header [title]="data.title" data-testid="confirm-dialog-header" />
<div class="dialog-content" data-testid="confirm-dialog-content">
  <div class="message" data-testid="confirm-dialog-message">{{ data.message }}</div>
</div>
<orbit-dialog-footer data-testid="confirm-dialog-footer">
  <div class="right-addon" right-addon>
    <orbit-button
      [flat]="true"
      [disabled]="false"
      [label]="data.cancelLabel"
      (onClick)="closeDialog(false)"
      data-testid="btn-confirm-dialog-cancel" />
    <orbit-button
      [disabled]="false"
      [label]="data.confirmLabel"
      [icon]="data.confirmIcon"
      (onClick)="closeDialog(true)"
      data-testid="btn-confirm-dialog-confirm" />
  </div>
</orbit-dialog-footer>
